import { createApp } from 'vue'
import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'

//Toast
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'

import * as Sentry from "@sentry/vue"
// Create vue app
const app = createApp(App)

//Toast options
const options = {
    position: "top-right",
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: true,
}

app.use(Toast, options)


// Register plugins
registerPlugins(app)


// Sentry.init({
//     app,
//     dsn: "https://ea9b2c112b5540f7feef45fff6deb14b@sentry.smartbytes.ir/9",
//     sendDefaultPii: true,
//     integrations: [
//         Sentry.replayIntegration(),
//       ],
//       tracesSampleRate: 1.0, // Capture 100% of the transactions
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       tracePropagationTargets: ["localhost", /^https:\/\/faradid\.ssl\.qom\.ac\.ir\/api/],
//       // Session Replay
//       replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//       replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })


// Mount vue app
app.mount('#app')
